import axios from 'axios';

import { attachAccessToken } from '../interceptors/attach-access-token';
import { attachOrganizationToken } from '../interceptors/attach-organization-token';
import { attachSiteToken } from '../interceptors/attach-site-token';

const api = axios.create({
  baseURL: `${import.meta.env.VITE_API_URL}/organization-admin-api`,
});

api.interceptors.request.use(attachAccessToken);
api.interceptors.request.use(attachOrganizationToken);
api.interceptors.request.use(attachSiteToken);

export default api;
